module.exports = __webpack_public_path__ + "img/bridgedetails3.f28be457.jpg";